export function onEnter (fns = []) {
  const next = () => Promise.resolve()
  const finish = () => Promise.reject()

  return (nextState, replace, done) => {
    let promise = Promise.resolve()

    for (let i = 0; i < fns.length; i++) {
      promise = promise.then(() => fns[i](nextState, replace, next, finish))
    }

    promise.then(done, done)
  }
}

export function onChange (fns = []) {
  const next = () => Promise.resolve()
  const finish = () => Promise.reject()

  return (prevState, nextState, replace, done) => {
    let promise = Promise.resolve()

    for (let i = 0; i < fns.length; i++) {
      promise = promise.then(() => fns[i](prevState, nextState, replace, next, finish))
    }

    promise.then(done, done)
  }
}

export function onLeave (fns = []) {
  const next = () => Promise.resolve()
  const finish = () => Promise.reject()

  return prevState => {
    let promise = Promise.resolve()

    for (let i = 0; i < fns.length; i++) {
      promise = promise.then(() => fns[i](prevState, next, finish))
    }
  }
}



// WEBPACK FOOTER //
// ./src/routes/middleware/composeRouteHooks.js